import {
	DefaultButton,
	DialogFooter,
	PrimaryButton,
	Stack,
} from '@fluentui/react';
import { observer } from 'mobx-react';
import React from 'react';
import { EntityType, IGenericEntity } from '../../API';
import EntityDashboardState from '../../state/EntityDashboardState';
import { IUserConfigPackage } from '../../API';
import EntityDashboard from '../dashboards/EntityDashboard';
import GenericDialog from '../pages/GenericDialog';
import { EntityDetailsState } from '../controls/EntityDetails';

export interface IEntitySelectorDialogProps {
	dialogTitle: string;
	entityType: EntityType | string;
	userConfig: IUserConfigPackage;
	onSelect: (items: IGenericEntity[]) => void;
	onCancel: () => void;
	visible: boolean;
	multi: boolean;
	detailsState: EntityDetailsState;
}

interface IEntitySelectorDialogState {
	selectedItems: IGenericEntity[];
	dashboard: EntityDashboardState;
}

class EntitySelectorDialogCtrl extends React.Component<
	IEntitySelectorDialogProps,
	IEntitySelectorDialogState
> {
	constructor(props: IEntitySelectorDialogProps) {
		super(props);
		this.state = {
			selectedItems: [],
			dashboard: new EntityDashboardState(
				this.props.entityType,
				this.props.userConfig,
				this.props.detailsState,
				true,
				true,
			),
		};
	}

	render() {
		if (!this.props.visible) {
			return <></>;
		}

		return (
			<>
				<GenericDialog
					fullScreen={false}
					visible={true}
					onDismiss={() => {
						this.props.onCancel();
					}}
					title={this.props.dialogTitle}
				>
					<Stack>
						<EntityDashboard
							state={this.state.dashboard}
							/* item double-click selects it immediately and closes the dialog */
							onItemInvoked={(item) => this.props.onSelect([item])}
							onSelectionChanged={(items: IGenericEntity[]) => {
								this.setState({ selectedItems: items });
							}}
						/>

						{this.props.children}

						<DialogFooter>
							<DefaultButton
								onClick={() => {
									this.props.onCancel();
								}}
							>
								Cancel
							</DefaultButton>
							<PrimaryButton
								disabled={this.state.selectedItems.length === 0}
								onClick={() => {
									this.props.onSelect(this.state.selectedItems);
								}}
							>
								Select
							</PrimaryButton>
						</DialogFooter>
					</Stack>
				</GenericDialog>
			</>
		);
	}
}

export default observer(EntitySelectorDialogCtrl);
